import { Injectable } from "@angular/core";
import {
  CanActivate, Router, CanActivateChild, ActivatedRouteSnapshot,
  RouterStateSnapshot
} from "@angular/router";
import { LoginUserService } from "./login-user.service";

@Injectable()
export class CanActivateWithLogin implements CanActivate {

  constructor(private _router: Router, private _logUser: LoginUserService) {
  }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    const needLogin = [
      '/user/student',
      '/user/company',
      '/talent',
    ];
    let tmp;
    // 不需要验证的模块
    if (!(tmp = needLogin.find(rec => state.url.indexOf(rec) !== -1))) {
      return true;
    } else if (!this._logUser.isLogin()) {    // 需要验证的场合
      // console.log("1cccc", 1111);
      this._router.navigate(['/']);
      return false;
    } else if (!!this._logUser.isLogin()) {
      if (this._logUser.isFistLogin) {  // 需要验证的场合
        this._router.navigate(['/user-info/user-complete']);
        return false;
      }
    }
    return true;
  }
}

@Injectable()
export class CanActivateByStudent implements CanActivate {
  constructor(private _logUser: LoginUserService) {
  }
  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {

    let uinfo = this._logUser.getLoginInfo();

    if (uinfo.type === '1') {
      return true;

    } else {

      return false;
    }

  }

}

@Injectable()
export class CanActivateChildWithLogin implements CanActivateChild {
  constructor(private _router: Router, private _logUser: LoginUserService) {
  }
  canActivateChild(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    const needLogin = [
      '/user/student',
      '/user/company',
      '/talent',
    ];
    let tmp;
    // 不需要验证的模块
    if (!(tmp = needLogin.find(rec => state.url.indexOf(rec) !== -1))) {
      return true;
    } else if (!this._logUser.isLogin()) {    // 需要验证的场合
      // console.log("3CanActivate", 1111);
      this._router.navigate(['/']);
      return false;
    } else if (!!this._logUser.isLogin()) {
      tmp = needLogin.find(rec => state.url.indexOf(rec) !== -1);
      let userType = this._logUser.getLoginInfo()['type'];

      if (!this._logUser.getLoginInfo()['is_first_login']) {  // 需要验证的场合
        this._router.navigate(['/user-info/user-complete']);
        return false;
      } else {
        switch (tmp) {
          case "/user/student":
            if (userType !== 1) {
              this._router.navigate(['/']);
              return false;
            }
            break;
          case "/user/company":
            if (userType !== 3) {
              this._router.navigate(['/']);
              return false;
            }
            break;
        }
      }
    }
    return true;
  }
}

@Injectable()
export class CanActivateAllRouter implements CanActivate {
  constructor(private _router: Router, private _logUser: LoginUserService, ) {
  }
  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    if (!this._logUser.isLogin()) { // 不需要验证的场合
      return true;
    } else if (!!this._logUser.isLogin()) {
      // console.log("can11::", this._logUser.getLoginInfo()['is_first_login'])
      if (!this._logUser.getLoginInfo()['is_first_login']) {  // 需要验证的场合

        this._router.navigate(['/user-info/user-complete']);
        return false;
      }
    }
    return true;
  }
}

@Injectable()
export class CanActivateTalentRouter implements CanActivate {
  constructor(private _router: Router, private _logUser: LoginUserService, ) {
  }
  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    if (!this._logUser.isLogin()) { // 不需要验证的场合
      this._router.navigate(['/']);
      return false;
    } else if (!!this._logUser.isLogin()) {
      if (this._logUser.getLoginInfo()['type'] !== 3) {  // 需要验证的场合
        this._router.navigate(['/']);
        return false;
      }
    }
    return true;
  }
}

@Injectable()
export class CanActivateChildWithUser implements CanActivateChild {
  constructor(private _router: Router, private _logUser: LoginUserService) {
  }
  canActivateChild(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    const needLogin = [
      '/user-info/user-complete',
      '/user-info/edit-student',
      '/user-info/setdata-company',
    ];
    let tmp;



    tmp = needLogin.find(rec => state.url.indexOf(rec) !== -1);
    if (!tmp) {
      return true;
    } else {
      //如果没有登录直接退出
      if (!this._logUser.isLogin()) {
        this._router.navigate(['/']);
        return false;
      } else {
        let userType = this._logUser.getLoginInfo()['type'];
        switch (tmp) {
          case "/user/student":
            if (userType !== 1) {
              this._router.navigate(['/']);
              return false;
            }
            break;
          case "/user/company":
            if (userType !== 3) {
              this._router.navigate(['/']);
              return false;
            }
            break;
        }
      }
    }
    return true;
  }
}




// WEBPACK FOOTER //
// /data/wwwroot/xzhipin/app-client/src/app/core/services/can-activate-guard.ts